export function normalizeDocumentDigits(document?: string | null): string {
  return String(document ?? "").replace(/\D/g, "").slice(0, 14);
}

export function isValidCpfOrCnpj(document?: string | null): boolean {
  const digits = normalizeDocumentDigits(document);
  return digits.length === 11 || digits.length === 14;
}

export function formatCpfOrCnpj(value: string): string {
  const digits = normalizeDocumentDigits(value);

  if (digits.length <= 11) {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) {
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    }
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(
      6,
      9
    )}-${digits.slice(9)}`;
  }

  if (digits.length <= 12) {
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(
      5,
      8
    )}/${digits.slice(8)}`;
  }

  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(
    5,
    8
  )}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}
